module.exports = __webpack_public_path__ + "icon-128-visualisation-line.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/icon-128-visualisation-line.png
// module id = 629
// module chunks = 11